import { BottomNavProps } from "models/bottomNav";
import { Image } from "components/Image";
import { menuItems } from "constants/general";
import {
  getUrlPathForMainMenu,
  pushToDataLayer,
} from "core/utils/utils.helper";
import { useNavigate } from "react-router-dom";
import { activeDateAtom } from "recLib/atoms/tracker";
import { useSetRecoilState } from "recoil";
import dayjs from "dayjs";
import { GERMAN_DATE_FORMAT } from "constants/date-time";
import styles from "./BottomNavMenu.module.scss";

import { BTN_SIZE, BTN_VARIANTS } from "constants/components";
import { Button } from "components/Button";
import useAuth from "hooks/useAuth";
import { CONTENT } from "constants/dataLayer";
import { pushAppsFlyerGtmEvent } from "@/core/utils/appsflyer-gtm.helper";
import { APPSFLYER_EVENTS } from "@/constants/appsflyer";

export const BottomNavMenu: React.FC<BottomNavProps> = (props) => {
  const navItems: any[] = Object.entries(menuItems)
    .filter((e) => e[1].enabled) // filter enabled items
    .map((e) => e[1]); // converting objects of objects to array of objects
  const selectedKey: any = getUrlPathForMainMenu(); // get currently selected menu
  const setChangeActiveDate = useSetRecoilState(activeDateAtom); // change horizontal calender selected date to null when sidemenu clicked
  const navigate = useNavigate();
  const auth: any = useAuth();
  const isLoggedIn = auth?.isAuthenticated ?? false;
  const onClick = (key: any) => {
    const item = navItems.find((o: any) => o.key === key);
    const path = item && Object.keys(item).length !== 0 ? item.to : "";
    pushToDataLayer({
      ...CONTENT.MENU,
      section_name: item?.value,
      event_name: `cta_menu_${item?.key}`.toLowerCase(),
    });
    pushAppsFlyerGtmEvent(
      `${APPSFLYER_EVENTS.TAB_SWITCHED}_${item?.key}`.toLowerCase(),
      {
        timestamp: Date.now(),
      },
    );
    setChangeActiveDate(dayjs().startOf("day").format(GERMAN_DATE_FORMAT));
    path && navigate(item?.key === "home" && !isLoggedIn ? "/" : path);
  };
  return (
    <div className={styles.bottom_nav_container}>
      {navItems?.map((item: any) => {
        return item?.value !== menuItems.TRACK.value ? (
          <Button
            className={`${styles.nav_item}`}
            onClick={() => onClick(item.key)}
            key={item?.key}
            type={BTN_VARIANTS.NEUTRAL}
            size={BTN_SIZE.NEUTRAL}
          >
            <figure>
              <Image
                source={
                  selectedKey && selectedKey === item.key
                    ? item.iconActive
                    : item.icon
                }
                altText=""
              />
              <figcaption
                className={
                  selectedKey && selectedKey === item.key
                    ? styles.nav_item__active
                    : ""
                }
              >
                {item?.value}
              </figcaption>
            </figure>
          </Button>
        ) : (
          <Button
            className={`${styles.nav_item}`}
            onClick={() => onClick(item.key)}
            key={item?.key}
            type={BTN_VARIANTS.NEUTRAL}
            size={BTN_SIZE.NEUTRAL}
          >
            <figure className={styles.item_track_wrapper}>
              <div className={styles.item_track_inner}>
                <div className={styles.item_track}>
                  <Image
                    source={item?.iconMobile}
                    altText=""
                    className={styles.track_add}
                  />
                </div>
              </div>
              <figcaption>{item?.value}</figcaption>
            </figure>
          </Button>
        );
      })}
    </div>
  );
};
